const cssVars = {
    colorPrimary: "var(--color-primary)",
    colorGrey: {
        0: "var(--color-grey-0)",
        1: "var(--color-grey-1)",
        2: "var(--color-grey-2)",
        3: "var(--color-grey-3)",
        4: "var(--color-grey-4)",
        5: "var(--color-grey-5)",
        6: "var(--color-grey-6)",
        "6h": "var(--color-grey-6-h)",
        7: "var(--color-grey-7)",
        "7h": "var(--color-grey-7-h)",
        8: "var(--color-grey-8)",
    }
}

export default cssVars;